module.exports = __webpack_public_path__ + "static/assets/93f07b8ff24136bf687d94ceaabff525.svg";